import React, { useEffect, useState } from "react";
import { Route, Link, Switch } from "react-router-dom";
import questionService from "../../services/question.service";
import { Label, Button, Modal, Checkbox, DropDownInput, Input } from '../../util/ui'
import CreateQuestionModal from "./question.create.component";

const Question = () => {
  const [showCreateQuestionModal, setShowCreateQuestionModal] = useState(false);

  const handleCreateQuestion = async (quizQuestionObj) => {
    try {
      await questionService.createQuestion(quizQuestionObj)

      // const response = await quizService.getQuizzes();
      // setQuizzes(response.quizzes);

    } catch (error) {
      console.error("Error creating question:", error);
    }
  }

  return (
    <div>
      <button onClick={() => setShowCreateQuestionModal(true)}>Create Question</button>

      <CreateQuestionModal
        isOpen={showCreateQuestionModal}
        setIsOpen={setShowCreateQuestionModal}
        onCreateQuestion={handleCreateQuestion}
      />

    </div>
  )
};

export default Question;